import { gql } from '@apollo/client';
import {
  CORE_GROUP_FIELDS,
  CORE_INVITATION_RESPONSE_FIELDS,
  CORE_MEMBER_FIELDS,
  CORE_PLAYLIST_FIELDS,
} from './fragments';

export const createGroup = gql`
  ${CORE_GROUP_FIELDS}
  mutation createGroup($input: CreateGroupInput!) {
    createGroup(input: $input) {
      ...CoreGroupFields
    }
  }
`;

export const deleteGroup = gql`
  ${CORE_GROUP_FIELDS}
  mutation deleteGroup($id: ID!, $organizationId: ID!) {
    deleteGroup(id: $id, organizationId: $organizationId) {
      ...CoreGroupFields
    }
  }
`;

export const deleteInvitations = gql`
  ${CORE_INVITATION_RESPONSE_FIELDS}
  mutation deleteInvitations($input: InvitationInput!) {
    deleteInvitations(input: $input) {
      ...CoreInvitationResponseFields
    }
  }
`;

export const deleteMember = gql`
  ${CORE_MEMBER_FIELDS}
  mutation deleteMember($userId: ID!, $organizationId: ID!) {
    deleteMember(userId: $userId, organizationId: $organizationId) {
      ...CoreMemberFields
    }
  }
`;

export const deleteMemberGroups = gql`
  ${CORE_GROUP_FIELDS}
  mutation deleteMemberGroups($memberId: ID!, $organizationId: ID!) {
    deleteMemberGroups(memberId: $memberId, organizationId: $organizationId) {
      ...CoreGroupFields
    }
  }
`;

export const deleteMemberPlaylists = gql`
  mutation deleteMemberPlaylists($memberId: ID!) {
    deleteMemberPlaylists(memberId: $memberId) {
      id
    }
  }
`;

export const resendInvitations = gql`
  ${CORE_INVITATION_RESPONSE_FIELDS}
  mutation resendInvitations($input: InvitationInput!) {
    resendInvitations(input: $input) {
      ...CoreInvitationResponseFields
    }
  }
`;

export const sendInvitations = gql`
  ${CORE_INVITATION_RESPONSE_FIELDS}
  mutation sendInvitations($input: InvitationInput!) {
    sendInvitations(input: $input) {
      ...CoreInvitationResponseFields
    }
  }
`;

export const transferGroup = gql`
  ${CORE_GROUP_FIELDS}
  mutation transferGroup($input: TransferGroupInput!) {
    transferGroup(input: $input) {
      ...CoreGroupFields
    }
  }
`;

export const transferUserGroups = gql`
  ${CORE_GROUP_FIELDS}
  mutation transferUserGroups($input: TransferUserGroupsInput!) {
    transferUserGroups(input: $input) {
      ...CoreGroupFields
    }
  }
`;

export const transferUserPlaylists = gql`
  ${CORE_PLAYLIST_FIELDS}
  mutation transferUserPlaylists($input: TransferUserPlaylistsInput!) {
    transferUserPlaylists(input: $input) {
      ...CoreOrganizationPlaylistFields
    }
  }
`;

export const updateGroup = gql`
  ${CORE_GROUP_FIELDS}
  mutation updateGroup($input: UpdateGroupInput!) {
    updateGroup(input: $input) {
      ...CoreGroupFields
    }
  }
`;

export const updateGroupMembers = gql`
  ${CORE_GROUP_FIELDS}
  mutation updateGroupMembers($input: UpdateGroupMembersInput!) {
    updateGroupMembers(input: $input) {
      ...CoreGroupFields
    }
  }
`;

export const updateMember = gql`
  ${CORE_MEMBER_FIELDS}
  mutation updateMember($input: UpdateMemberInput!) {
    updateMember(input: $input) {
      ...CoreMemberFields
    }
  }
`;
